import React, { useState, useContext } from "react";
import { Row, Col } from "react-bootstrap";
import CustomAlert from "../../shared/CustemAlert";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
import { MdLiveHelp } from "react-icons/md";
import HelpModal from "../../shared/HelpModal";
import HelpContext from "../../shared/context/HelpProvider";

const baseURL = process.env.REACT_APP_API;

export default function Add({ increment, counter }) {
  const [title, setTitle] = useState(""); // useState hook
  const [error, setError] = useState(false);
  const [isAdded, SetIsAdded] = useState(false);
  const axiosPrivate = useAxiosPrivate();
  const { showHelp, setShowHelp, saeef, setSaeef } = useContext(HelpContext);

  // handle change event
  const handleChange = (e) => {
    e.preventDefault(); // prevent the default action
    setTitle(e.target.value); // set name to e.target.value (event)
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let isMounted = true;
    const controller = new AbortController();

    const postData = async () => {
      try {
        const response = await axiosPrivate.post(
          baseURL + "jobs/amotmedacat/",
          { title: title.trim() },
          {
            signal: controller.signal,
          }
        );
        SetIsAdded(true);
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    postData();
    setTitle("");
    setError(false);
  };
  // render

  return (
    <div>
      <HelpModal />
      <center>
        <div className="card text-dark bg-light container p-3  border  ">
          <div className="card-header">
            <h3
              onClick={() => {
                setSaeef("25-ב");
                setShowHelp(true);
              }}
            >
              אמות מידה
              <span className="help">
                <MdLiveHelp />
              </span>
            </h3>
          </div>
          <div className="card-body">
            <Row>
              <Col>
                <form onSubmit={handleSubmit} className="mbsc-form-group">
                  <div className="form-group">
                    <label htmlFor="title">אמת מידה</label>
                    <input
                      type="text"
                      name="title"
                      value={title}
                      onChange={handleChange}
                      className="form-control"
                      id="text1"
                      placeholder="תקליד אמת מידה להוספה"
                    />
                  </div>
                  <br />
                  <button type="submit" className="btn btn-primary">
                    הוסף אמת מידה חדשה
                  </button>
                </form>
              </Col>
            </Row>

            {isAdded && (
              <CustomAlert
                setShow={SetIsAdded}
                alertHeader={title}
                alertBody="אמת המידה נוספה בהצלחה"
              />
            )}
          </div>
        </div>
      </center>
    </div>
  );
}
